import React, { useState } from 'react'
import TaskData from './TaskData.js'
import useAuth from '../../hooks/useAuth.js';
import SearchBar from '../SearchBar.js';
//import Sidebar from './Sidebar';

function ProjectTask() {
  const { auth } = useAuth();
  const [searchValue,setSearchValue] = useState('');
  return (
    <div>
      {/* <div>
        <SearchBar setSearchValue={setSearchValue}/>
      </div>    */}
    <div>
      <div className="border-b border-gray-d-200 dark:border-white flex justify-between">
        <h2 className="font-poppins font-medium text-[20px] leading-[100%] tracking-[0%] text-gray-main pb-3 dark:text-white">
        Welcome {(auth.profile_name !== 'null') ? auth.profile_name : auth.profile_username} - Task Page
        </h2>
      </div>
      <div >
        <TaskData searchValue={searchValue}/>
      </div>
    </div>
    </div>
  )
}

export default ProjectTask
